'use client';
import { MixpanelEvent } from '@/services/eventEnums';
import { MixpanelTracking } from '@/services/mixpanel';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { isPlatformExplore } from '@/constants';

import { usePathname } from 'next/navigation';
import { useShoppingCart } from '@/context/ShoppingCartContext';

function DownloadSampleDialog({ downloadSamplePropData }: { downloadSamplePropData: any }) {
  const { isUserLoggedIn, value, url, key, icon, data, eventName } = downloadSamplePropData;

  const { t } = useTranslation('provider');
  const [open, setOpen] = useState<boolean>(false);
  const pathname = usePathname();
  const { setDrawer, setOpenCreateAccountDrawer } = useShoppingCart();
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <ListItem>
        <ListItemButton
          className="quick-action-list-btn"
          aria-label={key}
          {...(isUserLoggedIn && {
            component: 'a',
            href: url,
            target: '_blank',
          })}
          onClick={() => {
            MixpanelTracking.getInstance().track(eventName, {
              product_name: `${data?.partner_name} - ${data?.product_name}`,
            });
            if (!isUserLoggedIn && isPlatformExplore) {
              setOpen(true);
            }
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={t(key)} />
        </ListItemButton>
      </ListItem>
      <Dialog
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="skywatch-dialog"
        PaperProps={{
          sx: {
            maxWidth: '340px !important',
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t(key)}
        </DialogTitle>
        <IconButton
          name="Close Delete Item"
          aria-label="close"
          className="close-btn"
          onClick={() => {
            setOpen(false);
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 15,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent className="thm-dialog-content pt-0">
          <Typography variant="body2" gutterBottom>
            {t('mustLoginToDownload')}
          </Typography>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={() => {
              MixpanelTracking.getInstance().track(MixpanelEvent.ACCOUNT_SIGN_UP_CLICK);
              const socialSignOnUrl = `/auth/login?returnTo=${pathname}?isSignUp=true`;
              window.location.href = socialSignOnUrl;
            }}
          >
            {t('drawer:createAccount')}
          </Button>
          <Typography className="mt-4" variant="body2">
            {t('orderImagery:noAccount3')}{' '}
            <Link
              fontWeight="600"
              onClick={() => {
                MixpanelTracking.getInstance().track(MixpanelEvent.ACCOUNT_SIGNIN_CLICK);
                const emailPasswordSignOnUrl = `/auth/login?returnTo=${pathname}`;
                // testing social signin feature with posthog
                if (isPlatformExplore) {
                  const socialSignInUrl = `/auth/login?returnTo=${pathname}`;
                  window.location.href = socialSignInUrl;
                } else {
                  window.location.href = emailPasswordSignOnUrl;
                }
              }}
              component="button"
            >
              {t('drawer:signIn')}
            </Link>
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DownloadSampleDialog;
